export default "__VITE_ASSET__568015ce__"